import { H2 } from 'foundations-components/transitional/components/H2';
import styled from 'academy-common-lib/utils/Styling';
import PublicContentCard from './PublicContentCard';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import usageTracker from '../../../utils/usageTracker';
import { useIsLoggedIn } from '../../publicLayout/publicQueries';
import { getSignupUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RelatedContentSection = styled.section.withConfig({
  displayName: "PublicPageRelatedContentSection__RelatedContentSection"
})(["min-height:400px;padding:48px 0;"]);
const ItemGrid = styled.div.withConfig({
  displayName: "PublicPageRelatedContentSection__ItemGrid"
})(["display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,max-content));grid-gap:24px;"]);
const PublicPageRelatedContentSection = ({
  items
}) => {
  const {
    isLoggedIn
  } = useIsLoggedIn();
  return /*#__PURE__*/_jsxs(RelatedContentSection, {
    "data-test-id": "public-page-related-content-section",
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.moreLikeThis"
      })
    }), /*#__PURE__*/_jsx(ItemGrid, {
      children: items.map(item => {
        const hrefInternal = `https://app.hubspot.com/academy/l/${item.type === 'LESSON' ? 'lessons' : 'tracks'}/${item.id}`;
        const hrefExternal = getProxyUrl(`${item.type === 'LESSON' ? 'lessons' : 'courses'}/${item.pagePath}`);
        const trackingHref = item.pagePath ? hrefExternal : hrefInternal;
        const href = isLoggedIn ? hrefInternal : getSignupUrl(item.type === 'LESSON' ? 'LESSON' : 'COURSE', item.id);
        return /*#__PURE__*/_jsx(PublicContentCard, {
          badge: item.seoBadge,
          categories: item.subCategories,
          duration: item.duration,
          href: href,
          name: item.name || '',
          onClick: () => {
            usageTracker.track('interaction', {
              action: 'related-content-click',
              href: trackingHref
            });
          },
          thumbnailUrl: item.previewThumbnailRectangleUrl,
          type: item.certification ? 'CERTIFICATION' : item.type === 'LESSON' ? 'LESSON' : 'COURSE'
        }, item.id);
      })
    })]
  });
};
export default PublicPageRelatedContentSection;